import noop from '@anm/helpers/noop';
import { useEffect, useRef, FC } from 'react';

import ShareDialog, { ShareDialogProps } from '../ShareDialog';

type ShareVideoPageProps = ShareDialogProps & {
  landingTabUrl: string;
  isDescription?: boolean;
  isWebinar?: boolean;
  onInit?(): void;
};

type DialogMeta = {
  title: string;
  description: string;
};

const ShareVideoPage: FC<ShareVideoPageProps> = ({
  landingTabUrl,
  isDescription = true,
  onInit = noop,
  isWebinar = false,
  ...otherProps
}) => {
  useEffect(() => {
    onInit();
  }, []);

  const pageType = isWebinar ? 'Webinar' : 'Landing page';

  const defaultDialogMeta = useRef<DialogMeta>({
    title: `Share your ${isWebinar ? 'webinar' : 'video page'} `,
    description: `You can turn the page on/off and customize its contents in <br /> <a href="${landingTabUrl}">the ${pageType} settings</a>`
  }).current;

  return (
    <ShareDialog
      title={defaultDialogMeta.title}
      description={isDescription ? defaultDialogMeta.description : undefined}
      {...otherProps}
    />
  );
};

export default ShareVideoPage;
